import React from 'react';
import { Landing } from './Landing.jsx';
import { Dashboard } from './Dashboard.jsx';
import { Admin } from './Admin.jsx';
import { LegalPage, Unsubscribed } from './Legal.jsx';

export function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/app') return <Dashboard />;
  if (path === '/admin') return <Admin />;
  if (path === '/privacy') return <LegalPage type="privacy" />;
  if (path === '/terms') return <LegalPage type="terms" />;
  if (path === '/unsubscribed' || path === '/unsubscribed.html') return <Unsubscribed />;
  return <Landing />;
}
